module.exports = __webpack_public_path__ + "media/images/enseignant_eleve_voiture-6ca9759c72fa32e648b66e9786c6924b.png";